/**
 * NumberControl — Number input with min/max bounds.
 */

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface NumberControlProps {
  value: number
  onChange: (v: number) => void
  label: string
  min?: number
  max?: number
}

export function NumberControl({
  value,
  onChange,
  label,
  min,
  max,
}: NumberControlProps) {
  const handleChange = (raw: string) => {
    const parsed = parseInt(raw, 10)
    if (Number.isNaN(parsed)) return
    const clamped = Math.min(max ?? Infinity, Math.max(min ?? -Infinity, parsed))
    onChange(clamped)
  }

  return (
    <div className="space-y-1.5">
      <Label className="text-[13px] font-medium text-gray-600">{label}</Label>
      <Input
        type="number"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        min={min}
        max={max}
      />
    </div>
  )
}
